import React, { useCallback, useState } from 'react'
import { HeaderItem } from './style'

interface TableHeadProps {
  headers: {
    name: string
    field: string
    sortable: boolean
    width?: number
    customElement?: () => JSX.Element
  }[]
  onSorting(field: string, order: string): void
  onSelectAllRows?: () => void
  enableCheckbox?: boolean
}

const TableHeader: React.FC<TableHeadProps> = ({
  headers,
  onSorting,
  onSelectAllRows,
  enableCheckbox
}) => {
  const [sortingField, setSortingField] = useState('')
  const [sortingOrder, setSortingOrder] = useState('ASC')

  const onSortingChange = useCallback(
    (field: string) => {
      let order =
        field === sortingField && sortingOrder === 'ASC' ? 'DESC' : 'ASC'
      if (!sortingField.length) {
        order = 'DESC'
      }
      if (field !== sortingField) {
        order = 'DESC'
      }
      setSortingField(field)
      setSortingOrder(order)
      onSorting(field, order)
    },
    [onSorting, sortingField, sortingOrder]
  )

  return (
    <thead>
      <tr>
        {enableCheckbox && (
          <HeaderItem
          // style={{ width: width || 'auto' }}
          // onClick={() => (sortable ? onSortingChange(field) : null)}
          // className={className + ' fw-bold'}
          >
            <input type="checkbox" name="" id="" onChange={onSelectAllRows} />
          </HeaderItem>
        )}
        {headers.map(({ name, field, sortable, width, customElement }) => {
          const classSort =
            (sortingField &&
              sortingField === field &&
              (sortingOrder === 'ASC' ? 'sorting_asc' : 'sorting_desc')) ||
            (sortable && 'sorting sorting_asc') ||
            ''

          const classAction = field === 'actions' ? 'actions' : ''

          const className =
            classSort + classAction + ' border-bottom border-end'

          if (customElement) {
            return customElement
          }
          return (
            <HeaderItem
              key={name}
              style={{ width: width || 'auto', cursor: sortable && 'pointer' }}
              onClick={() => (sortable ? onSortingChange(field) : null)}
              className={className + ' fw-bold'}
            >
              {name}
            </HeaderItem>
          )
        })}
      </tr>
    </thead>
  )
}
export default TableHeader
